import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.CaptainAmericano,
  voices: {
    main: {
      description:
        "middle-aged warm Latin American baritone, parade-ground clarity, brisk optimistic command, clean chest resonance, wholly original civic-hero tone",
      seed: 10001,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "Freedom's an IDEA that'll never die!" },
      { id: "select_2", text: "Steve Rogers, reporting for duty." },
      { id: "select_3", text: "Captain Americano, at your service." },
      { id: "select_4", text: "This is Captain Americano." },
      {
        id: "select_5",
        text: "I really miss the day when the weirdest thing science ever created was me.",
      },
    ],
    spawn: [
      { id: "spawn_1", text: "All charged up and ready for battle!" },
      {
        id: "spawn_2",
        text: 'Time to show our foes what "worthy" really means!',
      },
      {
        id: "spawn_3",
        text: "Just keep fighting. If you fall, I'll be there.",
      },
      {
        id: "spawn_4",
        text: "It's you and me 'til the end of the line, Bucky.",
      },
      { id: "spawn_5", text: "You can't be brave without being afraid first." },
      { id: "spawn_6", text: "Times change. People don't." },
      {
        id: "spawn_7",
        text: "Almost everyone knows what's right. Not everyone does it.",
      },
      {
        id: "spawn_8",
        text: "Alright. If anyone needs me, I'll be in my iceberg :)…That was… a joke. I can joke too, you know.",
      },
      {
        id: "spawn_9",
        text: "Past or future, as long as folks're living on their knees, I'll keep standing up.",
      },
      {
        id: "spawn_10",
        text: "Run the tactics again, everything has to be water tight.",
      },
      { id: "spawn_11", text: "I was always meant to be a soldier." },
      { id: "spawn_12", text: "I do the absolute best I can. Every time." },
      {
        id: "spawn_13",
        text: "If we don't stand up for what's right, who will?",
      },
      { id: "spawn_14", text: "Never forget who you are fighting for." },
      {
        id: "spawn_15",
        text: "This is war. We keep fighting until we can't fight anymore.",
      },
      {
        id: "spawn_16",
        text: "I fight for more than a flag. I fight for an idea. One bigger than all of us.",
      },
      { id: "spawn_17", text: "Freedom doesn't come without a fight." },
      {
        id: "spawn_18",
        text: "The Avengers were supposed to be different than S.H.I.E.L.D.",
      },
      {
        id: "spawn_19",
        text: "The world's a big place. Let's start making it smaller.",
      },
      {
        id: "spawn_20",
        text: "Every time someone tries to win a war before it starts, innocent people die. Every time.",
      },
      {
        id: "spawn_21",
        text: "Ultron thinks we're monsters and we're what's wrong with the world. This isn't just about beating him. It's about whether he's right.",
      },
      {
        id: "spawn_22",
        text: "Ultron's calling us out. And I'd like to find him before he's ready for us.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "You think I'm too old for this?" },
      { id: "respawn_2", text: "I never stay down." },
      { id: "respawn_3", text: "The fat lady isn't singing yet." },
      { id: "respawn_4", text: "Live to fight another day!" },
      { id: "respawn_5", text: "All right, don't rush in!" },
    ],
    ult_ally: [{ id: "ult_ally", text: "Together! To victory!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Assemble!" }],
    ability2: [
      { id: "ability2_1", text: "Catch!" },
      { id: "ability2_2", text: "Take THIS!" },
      { id: "ability2_3", text: "Let's dance." },
    ],
    ability3: [
      { id: "ability3_1", text: "Coming through!" },
      { id: "ability3_2", text: "Stand down!" },
      { id: "ability3_3", text: "Sorry, soldier!" },
    ],
    kill: [
      { id: "kill_1", text: "We're gonna do what we have to do." },
      { id: "kill_2", text: "Just here to do my duty." },
      { id: "kill_3", text: "I'm a soldier. This is war." },
      { id: "kill_4", text: "You're on the wrong side." },
      { id: "kill_5", text: "You're relieved of duty." },
      { id: "kill_6", text: "And stay down!" },
    ],
    multikill: [
      { id: "multikill_1", text: "Three hits!" },
      { id: "multikill_2", text: "Multiple targets down." },
      { id: "multikill_3", text: "I got three." },
      { id: "multikill_4", text: "That makes five!" },
      { id: "multikill_5", text: "Five down." },
      { id: "multikill_6", text: "Winning streak!" },
      { id: "multikill_7", text: "That's all of them." },
      { id: "multikill_8", text: "We're all clear." },
      { id: "multikill_9", text: "Anyone else? No?" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Back in the fight!" },
      { id: "low_hp_2", text: "Just in the nick of time!" },
    ],
    healed: [
      { id: "healed_1", text: "That's the boost I needed!" },
      { id: "healed_2", text: "I'll be ship shape in no time!" },
      { id: "healed_3", text: "These come in real handy." },
      { id: "healed_4", text: "Can't beat battlefield medicine." },
    ],
  },
} satisfies VoiceScript;

export default script;
